import { Fragment, useState } from 'react';

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import {
  ExpandMore,
  GroupOutlined,
  GroupWork,
  DriveFileRenameOutlineOutlined,
  SmartDisplayOutlined,
  ArticleOutlined,
} from '@mui/icons-material';
import Survey from '../../Main/Survey';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';
import useNotification from 'hooks/useNotification';
import usePatient from 'store/patient/usePatient';
import useSurvey from 'store/survey/useSurvey';
import { useNavigate } from 'react-router-dom';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  menuState: string;
  setMenuState: (menuState: string) => void;
}

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, setMenuState } = props;
  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const navigate = useNavigate();
  const { onUpdateSurveyType } = useSurvey();

  const changeMenu = (path: string, menuState: string) => {
    navigate(path);
    setMenuState(menuState);
  };

  const changeAssignment = () =>
    changeMenu('/professorAuth/assignment', '과제 제출 확인');

  const changeOriginMenu = () =>
    changeMenu('/professorAuth/video', '핵심간호술기영상 관리');

  const changeMenuNurseRecord = () =>
    changeMenu('/professorAuth/record', '간호기록 전체조회');

  const changeMenuList = () =>
    changeMenu('/professorAuth/list', '가상환자 리스트');

  const changeMenEditList = () =>
    changeMenu('/professorAuth/modify', '가상환자 수정');

  const changeClassSection = () =>
    changeMenu('/professorAuth/classSection', '분반 생성 및 관리');

  const menus = [
    {
      icon: <ArticleOutlined />,
      label: '과제 제출 확인',
      onclick: changeAssignment,
    },
    {
      icon: <SmartDisplayOutlined />,
      label: '핵심간호술기영상 관리',
      onclick: changeOriginMenu,
    },
    {
      icon: <DriveFileRenameOutlineOutlined />,
      label: '간호기록 전체조회',
      onclick: changeMenuNurseRecord,
    },
    {
      disabled: true,
      icon: <GroupOutlined />,
      label: '가상환자 관리',
      id: 'nurse_record',
    },
    {
      label: '가상환자 리스트',
      toggle: toggle.nurse_record,
      onclick: changeMenuList,
    },
    {
      label: '가상환자 수정',
      toggle: toggle.nurse_record,
      onclick: changeMenEditList,
    },
    {
      icon: <GroupWork />,
      label: '분반 생성 및 관리',
      onclick: changeClassSection,
    },
  ];

  const onClickListItem = (label: string) => {
    if (!patientInfo) {
      return onRequired('REQUIRED.PATIENT');
    }
    onUpdateSurveyType(label);
    return;
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    if (menuDrawerWidth !== 220) {
      if (sublabel) newToggle[sublabel] = true;
      setToggle(newToggle);
      setMenuDrawerWidth(220);
      return;
    }

    if (sublabel) newToggle[sublabel] = !newToggle[sublabel];
    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, onclick, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return (
            <ExpandMore
              fontSize="small"
              sx={{ color: '#333333', marginRight: '-8px', marginLeft: '7px' }}
            />
          );
        };

        return (
          <>
            {menuDrawerWidth !== 220 ? (
              icon ? (
                <ListItem key={label} disablePadding>
                  <ListItemButton onClick={onclick}>
                    <ListItemIcon
                      sx={{
                        color: '#333333 !important',
                        '& .MuiSvgIcon-root': {
                          color: '#333333 !important',
                        },
                      }}
                    >
                      {icon}
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              ) : null
            ) : icon ? (
              <ListItem key={label} disablePadding>
                <ListItemButton onClick={!disabled ? onclick : onClick}>
                  <ListItemIcon
                    sx={{
                      color: '#333333 !important',
                      '& .MuiSvgIcon-root': {
                        color: '#333333 !important',
                      },
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={label}
                    sx={{
                      '& .MuiTypography-root': {
                        color: '#333333 !important',
                        fontSize: '14px',
                        fontWeight: 600,
                      },
                    }}
                  />
                  <MoreIcon />
                </ListItemButton>
              </ListItem>
            ) : toggle ? (
              <ListItem key={label} disablePadding>
                <ListItemButton className={''} onClick={onclick}>
                  <ListItemIcon
                    sx={{
                      color: '#333333 !important',
                      '& .MuiSvgIcon-root': {
                        color: '#333333 !important',
                      },
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={label}
                    sx={{
                      whiteSpace: 'pre-wrap',
                      '& .MuiTypography-root': {
                        color: '#333333 !important',
                        fontSize: '14px',
                        fontWeight: 600,
                      },
                    }}
                  />
                  <MoreIcon />
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
          </>
        );
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
